import { fork } from "@redux-saga/core/effects";
import watchAppDetailSaga from "./features/feedback/saga";

export default function* rootSaga() {
  yield fork(watchAppDetailSaga);
}
